import { KeysOf } from '~types/common';

type MediaType = KeysOf<typeof mediaWidth>;
export type Media = {
  mobile: string;
  tablet: string;
  pc: string;
  with: (media1: MediaType, media2: MediaType) => string;
};

const breakpoint = {
  sm: 768,
  lg: 1200,
};

export const mediaWidth = {
  mobile: `(max-width: ${breakpoint.sm - 1}px)`,
  tablet: `(min-width: ${breakpoint.sm}px) and (max-width: ${breakpoint.lg - 1}px)`,
  pc: `(min-width: ${breakpoint.lg}px)`,
};

const media: Media = {
  mobile: `@media ${mediaWidth.mobile}`,
  tablet: `@media ${mediaWidth.tablet}`,
  pc: `@media ${mediaWidth.pc}`,
  with: (media1, media2) => {
    if ((media1 === 'mobile' && media2 === 'pc') || (media1 === 'pc' && media2 === 'mobile')) {
      return `@media (${mediaWidth['mobile']} and (${mediaWidth['pc']})`;
    }

    if (
      (media1 === 'mobile' && media2 === 'tablet') ||
      (media1 === 'tablet' && media2 === 'mobile')
    ) {
      return `@media (max-width: ${breakpoint.lg - 1}px)`;
    }

    if ((media1 === 'pc' && media2 === 'tablet') || (media1 === 'tablet' && media2 === 'pc')) {
      return `@media (min-width: ${breakpoint.sm}px)`;
    }

    return '';
  },
};

export default media;
